<template>
    <h5-dialog
        v-if="type === 'bind'"
        :title="$t('绑定邮箱')"
        :show-close-button="$route.name !== 'BindMobile'"
        @close="$emit('close')"
    >
        <div class="form">
            <div class="m-b-lg text-center">
                <div>
                    <i class="fa fa-warning m-r-sm" style="color: #ee0a24"></i>
                    <span>{{ $t('当前账号安全系数低') }}</span>
                </div>
                <div>
                    {{ $t('建议绑定邮箱') }}
                </div>
            </div>
            <div class="form-item">
                <h5-input v-model="bindForm.mobile" :placeholder="$t('请输入邮箱')"></h5-input>
            </div>
            <div class="form-item">
                <verify-code :mobile="bindForm.mobile" v-model="bindForm.code"></verify-code>
            </div>
        </div>
        <template v-slot:footer>
            <button class="btn btn-block btn-primary m-b" @click="startBindPhone">
                {{ $t('绑定邮箱') }}
            </button>
        </template>
    </h5-dialog>
    <h5-dialog v-else :title="$t('换绑邮箱')" :show-close-button="$route.name !== 'BindMobile'" @close="$emit('close')">
        <div class="form">
            <div class="m-b-lg text-center">
                <Steps :active="rebindStep" active-icon="arrow" active-color="var(--theme-color)" inactive-color="#ccc">
                    <Step></Step>
                    <Step>
                        {{ $t('验证原邮箱') }}
                    </Step>
                    <Step>
                        {{ $t('绑定新邮箱') }}
                    </Step>
                    <Step></Step>
                </Steps>
            </div>
            <div class="form-item">
                <h5-input v-model="bindForm.mobile"
                          :placeholder="rebindStep === 1 ? $t('请输入当前绑定邮箱码') : $t('请输入将要绑定的邮箱码')"></h5-input>
            </div>
            <div class="form-item">
                <verify-code ref="verifyCode" template="1" :mobile="bindForm.mobile" v-model="bindForm.code"></verify-code>
            </div>
        </div>
        <template v-slot:footer>
            <button class="btn btn-block btn-primary m-b" @click="rebindPhone">
                {{ rebindStep === 1 ? $t('开始验证') : $t('重新绑定') }}
            </button>
        </template>
    </h5-dialog>
</template>

<script>
import H5Dialog from '@/components/H5Dialog'
import H5Input from '@/components/H5Input'
import VerifyCode from '@/components/VerifyCode'
import { mobileRebind } from '@/service'
import { Step, Steps } from 'vant'
import { $t } from '@/utils/languages'

export default {
    name: 'BindMobile',
    components: { VerifyCode, H5Input, H5Dialog, Step, Steps },
    props: {
        type: {
            default: 'bind', // rebind
            type: String,
        },
        closable: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            bindForm: {
                mobile: '',
                code: '',
            },
            rebindStep: 1,
            binding: false,
        }
    },
    methods: {
        checkForm() {
            return new Promise(resolve => {
                if (this.bindForm.mobile === '') {
                    this.$toast($t('请输入邮箱'))
                    return false
                } else if (this.bindForm.code === '') {
                    this.$toast($t('请输入验证码'))
                    return false
                }
                resolve()
            })
        },
        startBindPhone() {
            this.checkForm().then(() => {
                if (this.binding) { return false}
                this.$toast.loading($t('正在绑定邮箱'))
                this.binding = true
                mobileRebind({
                    email: this.bindForm.mobile,
                    code: this.bindForm.code,
                    update: 0,
                }).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast({
                            message: $t('绑定成功'),
                            onClose: () => {
                                this.$emit('bind-success')
                            },
                        })
                    } else {
                        this.$toast(res.msg || $t('绑定失败'))
                    }
                }).finally(() => {
                    this.binding = false
                })
            })
        },
        rebindPhone() {
            this.checkForm().then(() => {
                if (this.binding) { return false}
                this.binding = true
                this.$toast.loading(this.rebindStep === 1 ? $t('正在验证原邮箱') : $t('正在绑定邮箱'))
                mobileRebind({
                    email: this.bindForm.mobile,
                    code: this.bindForm.code,
                    update: this.rebindStep === 1 ? 0 : 1,
                }).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast({
                            icon: 'success',
                            message: $t('验证成功'),
                            onClose: () => {
                                this.bindForm = {
                                    mobile: '',
                                    code: '',
                                }
                                if (this.rebindStep === 1) {
                                    this.$refs.verifyCode && this.$refs.verifyCode.clearCountDown()
                                    this.rebindStep = 2
                                } else {
                                    this.rebindStep = 3
                                    this.$emit('bind-success')
                                }
                            },
                        })
                    } else {
                        this.$toast(res.msg || $t('验证失败'))
                    }
                }).finally(() => {
                    this.binding = false
                })
            })
        },
    },
}
</script>

<style scoped>

</style>
